import { AxiosResponse } from 'axios';
import axios from 'axios';
import API from '../Common/axios';

export type ShrineFile = {
  id: string;
  storage: 'store';
  metadata: {
    filename: string;
    mime_type: string;
    size: number;
  };
};

export type PresignResponse = {
  upload: {
    url: string;
    method: 'PUT';
    headers: Record<string, string>;
    shrine: ShrineFile;
  };
};

export type MetadataResponse = {
  id: number;
  filename: string;
  size: number;
  mime_type: string;
  url?: string;
};

export type RegisterRequestUploadViewResponse = {
  url: string;
  filename: string;
  size: number;
  mime_type: string;
};

export async function presignUpload(registerRequestId: number, file: File): Promise<PresignResponse> {
  const res: AxiosResponse<PresignResponse> = await API.post(
    `/v1/register_requests/${registerRequestId}/uploads/presign`,
    {
      file: {
        filename: file.name,
        content_type: file.type || 'application/octet-stream',
        byte_size: file.size,
      },
    }
  );

  return res.data;
}

export async function putToBucket(
  url: string,
  headers: Record<string, string>,
  file: File,
  onProgress?: (pct: number) => void
): Promise<void> {
  await axios.put(url, file, {
    headers,
    timeout: 60000,
    onUploadProgress: (e) => {
      if (!onProgress || !e.total) return;
      const pct = Math.round((e.loaded / e.total) * 100);
      onProgress(pct);
    },
  });
}

export async function saveMetadata(registerRequestId: number, shrine: ShrineFile): Promise<MetadataResponse> {
  const res: AxiosResponse<MetadataResponse> = await API.post(
    `/v1/register_requests/${registerRequestId}/uploads/metadata`,
    {
      file: shrine,
    }
  );

  return res.data;
}

export async function getRegisterRequestUploadView(
  registerRequestId: number,
  registerRequestFileId: number
): Promise<RegisterRequestUploadViewResponse> {
  const res: AxiosResponse<RegisterRequestUploadViewResponse> = await API.get(
    `/v1/register_requests/${registerRequestId}/register_request_uploads/${registerRequestFileId}/view`
  );

  return res.data;
}

export async function deleteRegisterRequestUpload(
  registerRequestId: number,
  registerRequestFileId: number
): Promise<void> {
  await API.delete(`/v1/register_requests/${registerRequestId}/register_request_uploads/${registerRequestFileId}`);
}
